































import WarehouseItemCustomization from "@/models/WarehouseItemCustomization";
import CustomizationPrintArea from "@/models/PrintAreaCustomization";
import { customizationStore } from "@/store/typed";
import CustomizationPrintAreaItem from "@/components/Customizer/CustomizationPrintArea/Item.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({ components: { CustomizationPrintAreaItem } })
export default class WarehouseItemListItem extends Vue {
  @Prop({ required: true }) customization!: WarehouseItemCustomization;

  private open = true;

  get printAreas() {
    return this.customization.printAreaCustomizations.map(
      (cpa: CustomizationPrintArea) => cpa.printArea
    );
  }

  onSelect() {
    customizationStore.setMode('2d');
    if (customizationStore.navigationLocked) {
      return;
    }
    customizationStore.setWarehouseItemCustomization(this.customization);
  }

  get printAreaCustomizations() {
    return this.customization?.printAreaCustomizations;
  }

  get warehouseItem() {
    return this.customization.warehouseItem;
  }

  get image() {
    return this.warehouseItem?.image;
  }

  get icon() {
    return this.open ? "angle-up" : "angle-down";
  }

  get current() {
    return (
      customizationStore.currentWarehouseItemCustomization?.id ===
      this.customization.id
    );
  }

  currentPrintArea(id: string) {
    return (
      customizationStore.currentPrintAreaCustomization?.printArea?.id === id
    );
  }
}
